import * as envSsm from 'env-ssm';
import React from 'react';
import {
  FaHome,
  FaSearch,
  FaBookOpen,
  FaUserAlt,
  FaBookMedical,
} from 'react-icons/fa';

import PropTypes from 'prop-types';

const CrossLoggerPlugin = require('cross-logger-plugin');

const logger = new CrossLoggerPlugin(
  `App:${__filename.replace(__dirname, '')}`,
);

class Footer extends React.Component {
  static propTypes = {
    context: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    // ----------------------------
    // initializeData
    // ----------------------------
    const { initializeData } = this.props.context;
  }

  render() {
    return <footer className="fixed-bottom bg-white" />;
  }
}

export default Footer;
